import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useCompliances = defineStore('compliances', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.compliance_ListCompliances,
    dto: 'ComplianceDto',
    create: api.compliance_CreateCompliance,
    update: api.compliance_UpdateCompliance,
    delete: api.compliance_DeleteCompliance,
    usage: api.compliance_GetComplianceUsage,
    signalR: 'ComplianceUpdate',
  });

  const testResults = [
    { id: 0, name: 'Not Set' },
    { id: 1, name: 'Pass' },
    { id: 2, name: 'Fail' },
  ];

  return {
    ...globalStoreBase,
    testResults,
  };
});
